<div class="host-auto-popover" [ngStyle]="hostStyle">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'note'">
      <div class="header">
        <div class="left">
          {{ 'component.multi_house_calendar.note_title' | translate }}
          <!-- 日期备注 -->
        </div>
        <div class="right">
          <span class="link" (click)="onClickEditNote.emit()">
            {{ 'word.edit' | translate }}
            <!-- 编辑 -->
          </span>
        </div>
      </div>
      <div class="content">{{ noteText }}</div>
    </ng-container>

    <ng-container *ngSwitchCase="'oversale'">
      <div class="header">
        <div class="left">
          {{ 'component.multi_house_calendar.date_allow_oversold' | translate }}
          <!-- 该日期房间允许超售 -->
        </div>
        <div class="right">
          <span class="link" (click)="onClickEditOversale.emit()">
            {{ 'component.multi_house_calendar.to_set' | translate }}
            <!-- 去设置 -->
          </span>
        </div>
      </div>
      <div class="content">
        <div class="list" *ngIf="oversaleMap?.length">
          <div class="item">
            <span class="label">{{ 'operate.field.channel' | translate }}</span>
            <span class="sub-items">
              <span class="sub-item" *ngFor="let type of oversaleMap">{{ (type | thirdparty)?.name }}</span>
            </span>
          </div>
        </div>
        <p>
          {{ 'component.multi_house_calendar.oversold_info' | translate }}
        </p>
        <!-- 该日期设置了超售，百居易不再自动关房， 请您留意可能产生爆单的情况 -->
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'house-auto-managed'">
      <div class="header">
        <div class="left">
          {{ 'component.multi_house_calendar.stop_auto_manage_house' | translate }}
          <!-- 该房间停止自动开关房管理 -->
        </div>
        <div class="right">
          <span class="link" (click)="onClickEditHouseAutoManaged.emit()">
            {{ 'component.multi_house_calendar.to_set' | translate }}
            <!-- 去设置 -->
          </span>
        </div>
      </div>
      <div class="content">
        {{ 'component.multi_house_calendar.auto_manage_house_stopped_info' | translate }}
        <!-- 此房间的自动开关房管理已停止，请您留意可能产生爆单的情况 -->
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'type-auto-managed'">
      <div class="header">
        <div class="left">
          {{ 'component.multi_house_calendar.stop_auto_manage_inventory' | translate }}
          <!-- 该房型停止库存自动管理 -->
        </div>
        <div class="right">
          <span class="link" (click)="onClickEditTypeAutoManaged.emit()">
            {{ 'component.multi_house_calendar.to_set' | translate }}
            <!-- 去设置 -->
          </span>
        </div>
      </div>
      <div class="content">
        {{ 'component.multi_house_calendar.auto_manage_inventory_stopped_info' | translate }}
        <!-- 此房型的库存自动管理已停止，请您留意可能产生爆单的情况 -->
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'status-diff'">
      <div class="header">
        <div class="left">
          {{ 'component.multi_house_calendar.has_not_closed_channel' | translate }}
          <!-- 有未关房渠道 -->
        </div>
        <div class="right">
          <!-- {{ "component.multi_house_calendar.click_date_to_change_status" | translate }} -->
          <!-- 点击日期可修改房态 -->
        </div>
      </div>
      <div class="content">
        <div class="list">
          <div class="item" *ngIf="statusDiffList[0]">
            <span class="label">
              {{ 'component.multi_house_calendar.closed_channel' | translate }}
              <!-- 已关闭： -->
            </span>
            <div class="sub-items">
              <span class="sub-item" *ngFor="let p of statusDiffList[0]">
                {{ 'word.channel_' + p | translate }}
              </span>
            </div>
          </div>
          <div class="item" *ngIf="statusDiffList[1]">
            <span class="label red">
              {{ 'component.multi_house_calendar.opened_channel' | translate }}
              <!-- 已打开： -->
            </span>
            <div class="sub-items">
              <span class="sub-item" *ngFor="let p of statusDiffList[1]">
                {{ 'word.channel_' + p | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'inventory-diff'">
      <div class="header">
        <div class="left">
          {{ 'component.multi_house_calendar.inconsistent_inventory' | translate }}
          <!-- 渠道库存与本地不同 -->
        </div>
        <div class="right">
          {{ 'component.multi_house_calendar.syn_inventory' | translate }}
          <!-- 点击日历同步库存 -->
        </div>
      </div>
      <div class="content">
        <div class="list">
          <div class="item" *ngIf="$any(inventoryDiffList)?.diff_thirdparty?.length">
            <span class="label red">
              {{ 'component.multi_house_calendar.different_inventory' | translate }}
              <!-- 库存不同： -->
            </span>
            <div class="sub-items" *ngFor="let p of $any(inventoryDiffList)?.diff_thirdparty">
              <span class="sub-item">
                {{ 'word.channel_' + p | translate }}
              </span>
            </div>
          </div>
          <div class="item" *ngIf="$any(inventoryDiffList)?.identical_thirdparty?.length">
            <span class="label">
              {{ 'component.multi_house_calendar.same_inventory' | translate }}
              <!-- 库存相同： -->
            </span>
            <div class="sub-items" *ngFor="let p of $any(inventoryDiffList)?.identical_thirdparty">
              <span class="sub-item">
                {{ 'word.channel_' + p | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'note-edit'">
      <div class="header">
        <div class="left">
          {{ 'component.multi_house_calendar.note_title' | translate }}
          <!-- 日期备注 -->
        </div>
        <div class="right">
          <span class="link" (click)="onClickConfirmEditNote.emit(noteText)">
            {{ 'word.save' | translate }}
            <!-- 保存 -->
          </span>
          <span class="link" (click)="onClickCancelEditNote.emit()">
            {{ 'word.cancel' | translate }}
            <!-- 取消 -->
          </span>
        </div>
      </div>
      <div class="content">
        <textarea nz-input rows="3" maxlength="50" [(ngModel)]="noteText" style="resize: none"></textarea>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'dirty-house'">
      <div class="content vertical">
        <div
          class="item padding-left"
          [class.with-checked-icon]="cleanStatus === 3"
          (click)="onClickUpdateCleanStatus.emit(3)"
        >
          {{ 'word.room_not_cleaned' | translate }}
          <!-- 脏房 -->
        </div>
        <div
          class="item padding-left"
          [class.with-checked-icon]="cleanStatus === 1"
          (click)="onClickUpdateCleanStatus.emit(1)"
        >
          {{ 'word.cleaned' | translate }}
          <!-- 已保洁 -->
        </div>
        <!--        <div-->
        <!--          class="item"-->
        <!--          (click)="onClickUpdateCleanStatus.emit(0)">-->
        <!--          {{ "word.no_cleaning" | translate }}-->
        <!--           免打扫 -->
        <!--        </div>-->
        <!--        <div-->
        <!--          class="item"-->
        <!--          (click)="onClickArrangeClean.emit()">-->
        <!--          {{ "word.arrange_cleaning" | translate }}-->
        <!--           安排保洁 -->
        <!--        </div>-->
      </div>
    </ng-container>
  </ng-container>
</div>
